/* eslint-disable @typescript-eslint/ban-ts-comment */
import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";

import { combinedReducers } from "./reducers";
import rootSaga from "./sagas";

export type CombinedReducersType = ReturnType<typeof combinedReducers>;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = CombinedReducersType;

export const storeFactory = (preloadedState: Partial<RootState> = {}) => {
  const sagaMiddleware = createSagaMiddleware();
  const store = configureStore({
    reducer: combinedReducers,
    devTools: true,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActionPaths: ["payload.actions"],
          ignoredPaths: ["modalState.props"],
        },
      }).concat(sagaMiddleware),
    preloadedState,
  });

  sagaMiddleware.run(rootSaga);
  // @ts-ignore
  if (window.Cypress) {
    // @ts-ignore
    window.store = store;
  }
  return store;
};

export type AppDispatch = ReturnType<typeof storeFactory>["dispatch"];
